export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YLJvik8s6yLUrwB0lw.cc0c21bd.woff2";